import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, ButtonGroup, OverlayTrigger, Popover } from 'react-bootstrap';

import SessionStore from 'stores/SessionStore';

import { ACCEPTED } from 'constants/JobStatus';

import { withTranslation, Translation, Trans } from 'react-i18next';

const MIN_CANCELLATION_LEAD_TIME_MIN = 180;

function getCancelOverlay() {
  return (
    <Popover id="cancel-popover">
      <Translation>
        {(t) => <p>{t('SHIPMENT_CAN_NOT_CANCEL_WITH_CARRIER')}</p>}
      </Translation>
      <Translation>
        {(t) => <p>{t('CONTACT_CARGOMATIC_SUPPORT_FOR_CANCELLATION')}</p>}
      </Translation>
    </Popover>
  );
}

class Cancel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelToggled: false,
    };
  }

  canCancelAsCarrier() {
    const {
      job: { current_status, pickup_after: pickupAfter },
    } = this.props;
    const now = moment();
    const pickup_after = moment(pickupAfter);
    const pickupTimeWithinCancelRange =
      pickup_after.diff(now, 'minutes') > MIN_CANCELLATION_LEAD_TIME_MIN;
    if (current_status === ACCEPTED && pickupTimeWithinCancelRange) {
      return true;
    }

    return false;
  }

  canCancelAsShipper() {
    return !this.props.job.carrier;
  }

  canCancelShipment() {
    if (!SessionStore.isShipper() && this.canCancelAsCarrier()) {
      return true;
    }
    if (SessionStore.isShipper() && this.canCancelAsShipper()) {
      return true;
    }

    return false;
  }

  renderConfirmation() {
    const { t } = this.props;
    if (!this.state.cancelToggled) {
      return null;
    }
    return (
      <div>
        <p>
          <Trans
            i18nKey="CANCEL_SHIPMENT_CONFIRMATION"
            values={{
              shipment_id: this.props.job.shipment_id,
            }}
            components={[<strong />]}
          />
        </p>
        <ButtonGroup>
          <Button onClick={() => this.setState({ cancelToggled: false })}>
            {t('NO')}
          </Button>
          <Button
            bsStyle="danger"
            onClick={() =>
              this.props.onCancelShipment({
                message: '',
              })
            }
          >
            {t('YES_CANCEL_SHIPMENT')}
          </Button>
        </ButtonGroup>
      </div>
    );
  }

  renderCancelButton(canCancel) {
    const { t } = this.props;
    return (
      <span className="cancel-btn-wrapper">
        <button
          className="button button-red"
          disabled={!canCancel}
          onClick={() => this.setState({ cancelToggled: true })}
        >
          {t('CANCEL_SHIPMENT')}
        </button>
      </span>
    );
  }

  render() {
    const canCancel = this.canCancelShipment();
    return (
      <section>
        {!this.state.cancelToggled && !canCancel && (
          <OverlayTrigger
            placement="right"
            trigger={['hover', 'focus']}
            overlay={getCancelOverlay()}
          >
            {this.renderCancelButton(canCancel)}
          </OverlayTrigger>
        )}
        {!this.state.cancelToggled &&
          canCancel &&
          this.renderCancelButton(canCancel)}
        {this.state.cancelToggled && this.renderConfirmation()}
      </section>
    );
  }
}

Cancel.propTypes = {
  job: PropTypes.shape({
    shipment_id: PropTypes.string.isRequired,
    current_status: PropTypes.string.isRequired,
  }).isRequired,
  onCancelShipment: PropTypes.func.isRequired,
};

export default withTranslation()(Cancel);
